import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { fakturniaAnimations } from '@fakturnia/animations';
import { RouterLink } from '@angular/router';


@Component({
  selector: 'premium-extend',
  standalone: true,
  imports: [CommonModule, MatButtonModule, RouterLink],
  animations   : fakturniaAnimations,
  templateUrl: './premium-extend.component.html',
  styleUrl: './premium-extend.component.scss'
})
export class PremiumExtendComponent {
  @Input() reason = 'LIMIT_EXCEEDED';
  @Output() readonly onExtendSubscriptionButtonClick: EventEmitter<boolean> = new EventEmitter<boolean>();
}
